import httpUtils from '@/api'

const state = {
  // 配置
  title: '新冠肺炎智能问答', // 页面标题
  guideStr: '您好，我是“新型冠状病毒感染的肺炎”智能问答助手，可以向您科普疫情知识，解答疫情相关问题。', // 引导语
  bannerUrl: 'https://static.wecity.qq.com/h5/2020-2/qabanner%20new-38c4481e0834a3c8a17c1d9b61dcc7f8.png',
  moreList: [],
  sharePicUrl: '',
  showHot: false,
  showReference: false,
  boxTab: [],
  intentList: [], // 问题分类列表
  showGuideQues: false, // 是否显示开屏问题
  recommands: [], //开屏问题
}

const mutations = {
  SET_AIQA_CONF(state, {
    title,
    guideStr,
    bannerUrl,
    moreList,
    sharePicUrl,
    showHot,
    showReference,
    boxTab,
    intentList,
    showGuideQues,
    recommands,
  }) {
    if (title) state.title = title
    if (guideStr) state.guideStr = guideStr
    if (bannerUrl) state.bannerUrl = bannerUrl
    if (moreList) state.moreList = moreList
    if (sharePicUrl) state.sharePicUrl = sharePicUrl
    if ([true, false].includes(showHot)) state.showHot = showHot
    if ([true, false].includes(showReference)) state.showReference = showReference
    if (boxTab) state.boxTab = boxTab
    if (intentList) state.intentList = intentList
    if (showGuideQues) state.showGuideQues = showGuideQues
    if (recommands) state.recommands = recommands
  }
}

const actions = {
  async fetchAiqaConf ({ commit }, { params } = {}) {
    const result = await httpUtils('GetNCovQAConfig', params, 'Diagnosis_NCOVQAServer_NCOVQAServant')
    if (result.code !== 0) {
      throw result
    }
    try {
      const {
        title,
        guide_words: guideStr,
        bannerUrl,
        moreList,
        sharePicUrl,
        showHot,
        showReference,
        boxTab,
        intentList,
        showGuideQues,
        recommands,
      } = JSON.parse(result.h5_config)
      commit('SET_AIQA_CONF', {
        title,
        guideStr,
        bannerUrl,
        moreList,
        sharePicUrl,
        showHot,
        showReference,
        boxTab,
        intentList,
        showGuideQues,
        recommands,
      })
    } catch(err) {
      console.log('parse config error')
      throw err
    }
  },
}

export default {
  namespaced: true,
  state,
  // getters,
  actions,
  mutations,
};
